/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
// styles
import { StyledSimpleCard } from './styles';
// assets
import iconDropdownArrowTop from '../../../assets/img/icon-arrow-dropdown-top.svg';
import iconDropdownArrowBottom from '../../../assets/img/icon-arrow-dropdown-bottom.svg';

const SimpleCard = (props) => {
  const {
    contentHeader,
    contentFooter,
    children,
    disabled,
    isDropdown,
    isCollapsed,
    onCollapse,
    withoutShadow,
    withoutBorder,
    className = '',
  } = props;

  const [isCollapsedInternal, setIsCollapsedInternal] = useState(true);

  useEffect(() => {
    /* istanbul ignore next */
    if (isCollapsed !== undefined) setIsCollapsedInternal(isCollapsed);
  }, [isCollapsed]);

  const handleCollapsed = () => {
    if (onCollapse && isCollapsed !== undefined) onCollapse(!isCollapsedInternal);
    else {
      // COMMENT: si definimos onCollapse para solo para saber el estado de acoplamiento, enviamos tal estado con onCollapse
      /* istanbul ignore next */
      if (onCollapse) onCollapse(!isCollapsedInternal);
      // COMMENT: como no tenemos isCollapsed, manejamos logica interna
      setIsCollapsedInternal(!isCollapsedInternal);
    }
  };

  return (
    <StyledSimpleCard
      className={`simplecard ${withoutShadow ? 'simplecard-without-shadow' : ''} ${
        withoutBorder ? 'simplecard-without-border' : ''
      } ${disabled === true ? 'simplecard--disabled' : ''} ${className}`}
    >
      <article
        className={`simplecard-head
          ${isDropdown ? 'card-internal-dropdown-head' : ''}
        `}
      >
        {contentHeader}
        {children && isDropdown && (
          <button type="button" className="btn-without-format--red-underline" onClick={() => handleCollapsed()}>
            <img
              src={isCollapsedInternal ? iconDropdownArrowBottom : iconDropdownArrowTop}
              width="14"
              alt=""
            />
          </button>
        )}
      </article>
      {children && (
        <article
          className={`simplecard-body position-static ${
            isDropdown && isCollapsedInternal ? 'simplecard-body--hidden' : ''
          }`}
        >
          {children}
        </article>
      )}
      {contentFooter && <article className="simplecard-foot">{contentFooter}</article>}
    </StyledSimpleCard>
  );
};

export default SimpleCard;
